import request from '@/utils/request';
export const defaultPoliciesDiscountData = {
  id: 0,
  enabled: true,
  discountType: 'percent',
  nettDiscount: 0,
  percentDiscount: 0,
  policyId: null,
  policy: {
    id: null
  },
  rangeId: null,
  range: {
    id: null
  },
  categoryId: null,
  category: {
    id: null
  },
  subCategoryId: null,
  subCategory: {
    id: null
  },
  productId: null,
  product: {
    id: null
  },
  productsVariationId: null,
  productsVariation: {
    id: null
  },
  dealersRoleId: null,
  dealersRole: {
    id: null
  }
};
export const getPoliciesDiscounts = params => request({
  url: '/policies-discounts',
  method: 'get',
  params
});
export const getPoliciesDiscountById = id => request({
  url: `/policies-discounts/${id}`,
  method: 'get'
});
export const updatePoliciesDiscount = (id, data) => request({
  url: `/policies-discounts/${id}`,
  method: 'patch',
  data
});
export const deletePoliciesDiscount = id => request({
  url: `/policies-discounts/${id}`,
  method: 'delete'
});
export const createPoliciesDiscount = data => request({
  url: '/policies-discounts',
  method: 'post',
  data
});
export const managePoliciesDiscount = data => request({
  url: '/policies-discounts/manage',
  method: 'post',
  data
});
export const downloadExcel = data => request({
  url: '/policies-discounts/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const importPoliciesDiscount = data => request({
  url: '/policies-discounts/import',
  method: 'post',
  data
});